import React from 'react';
import IconTipsCom from '@sg/components/IconTipsCom';
import { TOptionsItem } from '../types';

const OptionItemInfo = (props: { infoItem: TOptionsItem }) => {
  const { infoItem } = props || {};

  return infoItem?.info ? (
    <div className="db-option-info">
      <IconTipsCom
        tipString={infoItem.info}
        mWidth={314}
        style={{ width: 14, height: 14 }}
      />
    </div>
  ) : (
    ''
  );
};

export default OptionItemInfo;
